import { lazy } from "react";

// ** Document title
const TemplateTitle = "%s - Vuexy React Admin Template";

// ** Default Route
const DefaultRoute = "/login";

// ** Merge Routes
const Routes = [
  {
    path: "/auth",
    component: lazy(() => import("../../views/auth/index.js")),
    meta: {
      publicRoute: true,
    },
  },
  {
    path: "/dashboard",
    component: lazy(() => import("../../views/dashboard")),
    meta: {
      action: "Read",
      resource: "ok",
    },
  },
  {
    path: "/events",
    component: lazy(() => import("../../views/events")),
    meta: {
      action: "Read",
      resource: "ok",
    },
  },
  {
    path: "/event/create/:eventId",
    component: lazy(() => import("../../views/events/create/index.js")),
    meta: {
      action: "Update",
      resource: "Information",
    },
  },
  {
    path: "/roles&permissions",
    component: lazy(() => import("../../views/roles&permissions")),
    meta: {
      action: "Manage",
      resource: "All",
    },
  },
  {
    path: "/payments",
    component: lazy(() => import("../../views/moviments/payments")),
    meta: {
      action: "Manage",
      resource: "All",
    },
  },
  {
    path: "/:id/details",
    component: lazy(() => import("../../views/moviments/payments/details")),
    meta: {
      action: "Manage",
      resource: "All",
    },
  },
  {
    path: "/deposit",
    component: lazy(() => import("../../views/moviments/toDeposit")),
    meta: {
      action: "Manage",
      resource: "All",
    },
  },
  {
    path: "/users",
    component: lazy(() => import("../../views/users")),
    meta: {
      action: "Manage",
      resource: "All",
    },
  },
  {
    path: "/user/profile/:id",
    component: lazy(() => import("../../views/users/profile")),
    meta: {
      action: "Manage",
      resource: "All",
    },
  },
  {
    path: "/users/view",
    component: lazy(() => import("../../views/users/view")),
    meta: {
      action: "Manage",
      resource: "All",
    },
  },
  {
    path: "/user/create",
    component: lazy(() => import("../../views/users/create")),
    meta: {
      action: "Manage",
      resource: "All",
    },
  },
  {
    path: "/event/:eventId/home",
    component: lazy(() => import("../../views/home/index")),
    meta: {
      action: "Read",
      resource: "ok",
    },
  },
  {
    path: "/event/:eventId/notifications",
    component: lazy(() => import("../../views/notifications/index")),
    meta: {
      action: "Read",
      resource: "ok",
    },
  },
  {
    path: "/event/:id/landing/contact",
    component: lazy(() => import("../../views/landing/contact")),
    meta: {
      action: "Read",
      resource: "Information",
    },
  },
  {
    path: "/event/:id/landing/more",
    component: lazy(() => import("../../views/landing/more")),
    meta: {
      action: "Read",
      resource: "Information",
    },
  },
  {
    path: "/event/:id/landing/information",
    component: lazy(() => import("../../views/landing/information")),
    meta: {
      action: "Read",
      resource: "Information",
    },
  },
  {
    path: "/event/:eventId/landing/Gallery",
    component: lazy(() => import("../../views/landing/Gallery")),
    meta: {
      action: "Read",
      resource: "Information",
    },
  },
  {
    path: "/event/:id/landing/conferences",
    component: lazy(() => import("../../views/landing/conference")),
    meta: {
      action: "Read",
      resource: "Information",
    },
  },
  {
    path: "/:eventId/:id/landing/conferences/edit",
    component: lazy(() => import("../../views/landing/conference/item")),
    meta: {
      action: "Update",
      resource: "Information",
    },
  },
  {
    path: "/:id/landing/conferences/add",
    component: lazy(() => import("../../views/landing/conference/add")),
    meta: {
      action: "Update",
      resource: "Information",
    },
  },
  {
    path: "/event/:id/landing/speakers",
    component: lazy(() => import("../../views/landing/speakers")),
    meta: {
      action: "Read",
      resource: "Information",
    },
  },
  {
    path: "/:eventId/:id/landing/speakers/edit",
    component: lazy(() => import("../../views/landing/speakers/item")),
    meta: {
      action: "Read",
      resource: "Information",
    },
  },
  {
    path: "/:id/landing/speakers/add",
    component: lazy(() => import("../../views/landing/speakers/add")),
    meta: {
      action: "Update",
      resource: "Information",
    },
  },
  {
    path: "/event/:id/landing/sponsors",
    component: lazy(() => import("../../views/landing/sponsors/sponsorGroup")),
    meta: {
      action: "Read",
      resource: "Information",
    },
  },
  {
    path: "/:id/landing/sponsors/add",
    component: lazy(() => import("../../views/landing/sponsors/add")),
    meta: {
      action: "Read",
      resource: "Information",
    },
  },
  {
    path: "/:eventId/:id/landing/sponsors/edit",
    component: lazy(() => import("../../views/landing/sponsors/item")),
    meta: {
      action: "Read",
      resource: "Information",
    },
  },
  {
    path: "/event/:id/landing/exhibitors",
    component: lazy(() => import("../../views/exhibitors")),
    meta: {
      action: "Read",
      resource: "ok",
    },
  },
  {
    path: "/:eventId/:id/landing/exhibitors/details",
    component: lazy(() => import("../../views/exhibitors/datail")),
    meta: {
      action: "Read",
      resource: "ok",
    },
  },
  {
    path: "/event/:id/admin/tickets",
    component: lazy(() => import("../../views/admin/tickets")),
    meta: {
      action: "Read",
      resource: "Tickets",
    },
  },
  {
    path: "/event/:id/admin/reservations",
    component: lazy(() => import("../../views/admin/reservations")),
    meta: {
      action: "Read",
      resource: "Reservations",
    },
  },
  {
    path: "/event/:id/admin/orders",
    component: lazy(() => import("../../views/admin/orders")),
    meta: {
      action: "Read",
      resource: "Orders",
    },
  },
  {
    path: "/event/:id/admin/coupons",
    component: lazy(() => import("../../views/admin/coupons")),
    meta: {
      action: "Read",
      resource: "ok",
    },
  },
  {
    path: "/event/:id/admin/subscription",
    component: lazy(() => import("../../views/admin/subscriptions")),
    meta: {
      action: "Read",
      resource: "Subscriptions",
    },
  },
  {
    path: "/event/:id/admin/deposits",
    component: lazy(() => import("../../views/admin/deposits")),
    meta: {
      action: "Read",
      resource: "Information",
    },
  },
  {
    path: "/event/:id/admin/statistics",
    component: lazy(() => import("../../views/admin/statistics")),
  },
  {
    path: "/event/:eventId/admin/invitations",
    component: lazy(() => import("../../views/invitations")),
    meta: {
      action: "Read",
      resource: "ok",
    },
  },
  {
    path: "/:eventId/admin/invitations/detail/:id",
    component: lazy(() => import("../../views/invitations/detail")),
    meta: {
      action: "Read",
      resource: "ok",
    },
  },
  {
    path: "/event/:eventId/assistants",
    component: lazy(() => import("../../views/assistants")),
    meta: {
      action: "Read",
      resource: "ok",
    },
  },
  {
    path: "/:eventId/assistants/detail/:id",
    component: lazy(() => import("../../views/assistants/detail")),
    meta: {
      action: "Read",
      resource: "ok",
    },
  },
  {
    path: "/:eventId/assistants/badge/:id",
    component: lazy(() => import("../../views/assistants/badge")),
    meta: {
      action: "Read",
      resource: "ok",
    },
  },
  {
    path: "/:eventId/assistants/constancy/:id",
    component: lazy(() => import("../../views/assistants/constancy")),
    meta: {
      action: "Read",
      resource: "ok",
    },
  },
  {
    path: "/event/:id",
    component: lazy(() => import("../../views/admin/tickets")),
  },
  {
    path: "/:id/admin/tickets/create",
    component: lazy(() =>
      import("../../views/admin/tickets/create/createTicket")
    ),
    meta: {
      action: "Read",
      resource: "Tickets",
    },
  },
  {
    path: "/:id/admin/tickets/import",
    component: lazy(() => import("../../views/admin/tickets/import")),
    meta: {
      action: "Update",
      resource: "Tickets",
    },
  },
  {
    path: "/:id/admin/orders/create",
    component: lazy(() => import("../../views/admin/orders/create/index.js")),
    meta: {
      action: "Read",
      resource: "Orders",
    },
  },
  {
    path: "/:id/admin/coupons/create",
    component: lazy(() => import("../../views/admin/coupons/create/index.js")),
    meta: {
      action: "Read",
      resource: "ok",
    },
  },
  {
    path: "/:id/admin/coupons/collection",
    component: lazy(() => import("../../views/admin/coupons/collection")),
    meta: {
      action: "Read",
      resource: "ok",
    },
  },
  {
    path: "/:id/admin/checkout/create",
    component: lazy(() => import("../../views/admin/checkout/create")),
    meta: {
      action: "Update",
      resource: "ok",
    },
  },
  {
    path: "/:id/admin/subscriptions/create",
    component: lazy(() => import("../../views/admin/subscriptions/create")),
    meta: {
      action: "Update",
      resource: "Subscriptions",
    },
  },
  {
    path: "/:eventId/admin/tickets/detail/:id",
    component: lazy(() => import("../../views/admin/tickets/detail")),
    meta: {
      action: "Read",
      resource: "Tickets",
    },
  },
  {
    path: "/:eventId/admin/orders/detail/:id",
    component: lazy(() => import("../../views/admin/orders/detail")),
    meta: {
      action: "Read",
      resource: "Orders",
    },
  },
  {
    path: "/:eventId/admin/coupons/detail/:id",
    component: lazy(() => import("../../views/admin/coupons/detail")),
    meta: {
      action: "Read",
      resource: "ok",
    },
  },
  {
    path: "/:eventId/admin/reservations/detail/:id",
    component: lazy(() => import("../../views/admin/reservations/detail")),
    meta: {
      action: "Read",
      resource: "Reservations",
    },
  },
  {
    path: "/:eventId/admin/subscriptions/detail/:id",
    component: lazy(() => import("../../views/admin/subscriptions/detail")),
    meta: {
      action: "Read",
      resource: "Subscriptions",
    },
  },
  {
    path: "/:eventId/addons/list",
    component: lazy(() => import("../../views/addons")),
    meta: {
      action: "Read",
      resource: "addons",
    },
  },
  {
    path: "/:eventId/addons/details/:intId",
    component: lazy(() => import("../../views/addons/detail")),
    meta: {
      action: "Read",
      resource: "addons",
    },
  },
  {
    path: "/attendees/checkin",
    component: lazy(() => import("../../views/attendees/checkin")),
    meta: {
      action: "Read",
      resource: "addons",
    },
  },
  {
    path: "/attendees/list",
    component: lazy(() => import("../../views/attendees/list")),
    meta: {
      action: "Read",
      resource: "addons",
    },
  },
  {
    path: "/attendees/statistics",
    component: lazy(() => import("../../views/attendees/statistics")),
    meta: {
      action: "Read",
      resource: "addons",
    },
  },
  {
    path: "/signin-oidc",
    component: lazy(() => import("../../views/signin-oidc")),
    meta: {
      action: "Read",
      resource: "ok",
    },
  },
  {
    path: "/signout-oidc",
    component: lazy(() => import("../../views/signout-oidc")),
    meta: {
      action: "Read",
      resource: "ok",
    },
  },
  {
    path: "/login",
    component: lazy(() => import("../../views/login/index")),
    layout: "BlankLayout",
    meta: {
      authRoute: true,
    },
  },
  {
    path: "/error",
    component: lazy(() => import("../../views/Error")),
    layout: "BlankLayout",
  },
  {
    path: "/access-control",
    component: lazy(() => import("../../views/extensions/access-control")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
];

export { DefaultRoute, TemplateTitle, Routes };
